var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var SessionIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 65,
    glyphHeight: 65
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4111 7.34341C18.6654 7.34341 7.52224 18.4865 7.52224 32.2323C7.52224 45.9781 18.6654 57.1212 32.4111 57.1212C46.1569 57.1212 57.3 45.9781 57.3 32.2323C57.3 18.4865 46.1569 7.34341 32.4111 7.34341ZM0.411133 32.2323C0.411133 14.5592 14.738 0.2323 32.4111 0.2323C50.0842 0.2323 64.4111 14.5592 64.4111 32.2323C64.4111 49.9054 50.0842 64.2323 32.4111 64.2323C14.738 64.2323 0.411133 49.9054 0.411133 32.2323Z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.411 12.0841C34.3747 12.0841 35.9666 13.676 35.9666 15.6397V28.6767H49.0036C50.9673 28.6767 52.5592 30.2686 52.5592 32.2323C52.5592 34.1959 50.9673 35.7878 49.0036 35.7878H32.411C30.4473 35.7878 28.8555 34.1959 28.8555 32.2323V15.6397C28.8555 13.676 30.4473 12.0841 32.411 12.0841Z"
  }));
};
export var SessionIconGlyph = function (props) {
  return React.createElement(SessionIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};